import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import BrandLogo from "../components/shared/BrandLogo";

const PAGE = "min-h-[100dvh] pb-[env(safe-area-inset-bottom)] bg-[#f4f8fc] dark:bg-[#050d1e]";

export default function CheckEmail() {
  return (
    <div className={`${PAGE} flex flex-col items-center justify-center px-4`}
      style={{ paddingTop: "env(safe-area-inset-top)" }}
    >
      <div className="w-full max-w-md animate-in fade-in zoom-in duration-300">

        {/* Wordmark */}
        <div className="text-center mb-7">
          <BrandLogo variant="auto" className="w-14 h-14 mx-auto mb-2.5 object-contain" />
          <h1 className="text-[22px] font-bold text-brand dark:text-blue-400 tracking-tight">Kéves App</h1>
          <p className="text-[12px] text-slate-400 dark:text-slate-500 mt-1">Recuperación de contraseña</p>
        </div>

        {/* Card */}
        <div className="bg-white dark:bg-slate-900 rounded-[28px] shadow-[0_4px_24px_rgba(0,0,0,0.08)] dark:shadow-[0_8px_32px_rgba(0,0,0,0.4)] border border-slate-100 dark:border-slate-800 p-6 text-center space-y-4">

          <div className="h-16 w-16 rounded-[20px] bg-[#e3eefb] dark:bg-blue-900/20 flex items-center justify-center mx-auto shadow-sm">
            <Mail size={28} className="text-brand dark:text-blue-400" />
          </div>

          <div>
            <h2 className="text-[18px] font-bold text-slate-800 dark:text-slate-100 mb-1">Revisa tu correo</h2>
            <p className="text-[13px] text-slate-500 dark:text-slate-400 leading-relaxed">
              Te enviamos un enlace para continuar.
              Ábrelo desde tu correo para completar el proceso.
            </p>
          </div>

          <p className="text-[12px] text-slate-400 dark:text-slate-500">
            Si no lo encuentras, revisa la carpeta de spam o promociones.
          </p>

          <Link
            to="/login"
            className="flex items-center justify-center w-full h-12 bg-brand text-white rounded-[14px] font-semibold text-[15px] shadow-sm transition-all duration-200 hover:brightness-105 active:scale-[0.98]"
          >
            Volver al inicio
          </Link>

          <p className="text-[11px] text-slate-400 dark:text-slate-500">
            Puedes intentar nuevamente si no recibes el correo.
          </p>
        </div>

      </div>
    </div>
  );
}
